<template>
  <div>
    <v-card
      class="ma-4"
      elevation="4"
    >
      <v-card-title class="font-weight-bold">
        マイチャレンジ
      </v-card-title>

      <v-divider />

      <div class="pa-4">
        <ChallengeList :query="query" />
      </div>
    </v-card>
  </div>
</template>


<script>
import firebase from "@/firebase/firebase.js"
import {db} from "@/firebase/db.js"
import ChallengeList from '@/components/ChallengeList.vue'

export default {
  components: {
    ChallengeList,
  },
  data: () => ({
    query: null,
  }),
  created() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.query = db.collection('users').doc(user.uid).collection('challenges')
      }
    })
  }
};
</script>
